import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type AbTestDataFragment = (
  { testGroup: Types.AbTestGroup, testGroupLabel: string, testName: string }
  & { __typename: 'AbTestData' }
);


export type AbTestDataFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AbTestDataFragmentGql = `
    fragment AbTestDataFragment on AbTestData {
  testGroup
  testGroupLabel
  testName
  __typename
}
    `;